module.exports = __webpack_public_path__ + "img/insert.3c62439c.svg";